import { AuthContext } from './context'
import type { AuthProviderProps } from './types'

export const AuthServerProvider = ({ children, authStatus }: AuthProviderProps) => {
  return <AuthContext.Provider value={{ authStatus }}>{children}</AuthContext.Provider>
}
